// Split
import Image from 'next/image'

import PrismicLink from '@components/PrismicLink'

interface Props {
	slice: any
}

export default function Split({ slice }: Props) {
	// console.log('Split Slice ->', slice)
	const { primary } = slice

	// console.log(primary)

	return (
		<section
			className={`split section py-16 ${
				primary.theme?.uid ? `theme-${primary.theme.uid}` : 'theme-white'
			}`}
		>
			<div
				className={`container max-w-screen-lg flex flex-col px-8 md:space-x-8 ${
					slice.slice_label === 'image_right'
						? 'md:flex-row-reverse md:space-x-reverse'
						: 'md:flex-row'
				}`}
			>
				{/* Image */}
				<div className="flex flex-col justify-center md:w-2/5 max-md:mb-8">
					{primary.section_image?.medium?.url && (
						<Image
							src={primary.section_image.medium.url}
							width={primary.section_image.medium.dimensions.width}
							height={primary.section_image.medium.dimensions.height}
							alt={primary.section_image.alt ? primary.section_image.alt : ''}
						/>
					)}
				</div>

				{/* Text */}
				<div className="flex flex-col items-start justify-center md:w-3/5 md:py-12">
					{/* Title */}
					{primary.section_title?.[0] && (
						<h2 className="mb-4 text-4xl font-medium title">
							{primary.section_title[0].text}
						</h2>
					)}

					{/* <pre>{JSON.stringify(slice, null, 2)}</pre> */}

					{/* Description */}
					{/* TODO: Make richtext component */}
					{primary.section_description?.[0] && (
						<p className="subtitle max-w-[370px]">
							{primary.section_description[0].text}
						</p>
					)}

					{primary.section_cta && (
						<PrismicLink
							link={primary.section_cta}
							label={primary.section_cta_label || 'Get Started'}
							className={`mt-6 button button-${primary?.section_cta_color || 'primary'}`}
						/>
					)}
				</div>
			</div>
		</section>
	)
}
